import {
  createRootRouteWithContext,
  Outlet,
  ScrollRestoration,
} from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { Suspense, lazy } from "react";
import { LoadingState } from "@pureid/ui";
import { ErrorScreen } from "@/components/error-screen";

// Dev tools are lazy-loaded only in dev mode — zero cost in production.
const TanStackRouterDevtools = import.meta.env.PROD
  ? () => null
  : lazy(() =>
      import("@tanstack/router-devtools").then((m) => ({
        default: m.TanStackRouterDevtools,
      })),
    );

interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
  notFoundComponent: NotFound,
  errorComponent: RootErrorComponent,
});

function RootComponent() {
  return (
    <>
      <Suspense fallback={<LoadingState className="py-24" />}>
        <Outlet />
      </Suspense>
      <ScrollRestoration />
      {import.meta.env.DEV && (
        <Suspense>
          <TanStackRouterDevtools position="bottom-right" />
        </Suspense>
      )}
    </>
  );
}

function NotFound() {
  return (
    <ErrorScreen
      error={new Error("The requested resource was not found.")}
      title="Page not found"
      description="The page you were looking for doesn't exist, or the link is out of date."
    />
  );
}

function RootErrorComponent({
  error,
  reset,
}: {
  error: unknown;
  reset: () => void;
}) {
  return <ErrorScreen error={error} reset={reset} />;
}
